





































import { Component } from 'vue-property-decorator';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import PolicyStatusProgress from '@/views/pages/policies/PolicyStatusProgress.vue';
import { IUser } from 'admiral-core';
import { PermissionMixin } from '@/mixins/PermissionMixin';

@Component({
  name: 'agency-goal-selection-boxes',
  components: { PolicyStatusProgress },
})
export default class AgencyGoalSelectionBoxes extends mixins(FilterMixin, PermissionMixin) {}
